import React, { useState } from 'react';
import { Search, ShoppingCart, User, Globe, Menu, X, ChevronDown } from 'lucide-react';
import CiscoLogo from './CiscoLogo';
import { navItems } from '../mock';

const Header = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
      {/* Top utility bar */}
      <div className="hidden lg:flex justify-end items-center gap-6 px-8 py-2 text-xs text-gray-700">
        <a href="#" className="hover:text-[#00bceb]">Partners</a>
        <a href="#" className="hover:text-[#00bceb]">Find a reseller</a>
        <a href="#" className="hover:text-[#00bceb]">Contact Cisco</a>
        <span className="flex items-center gap-1"><Globe className="w-3.5 h-3.5" /> IN / EN</span>
        <a href="#" className="hover:text-[#00bceb]">Log in</a>
      </div>

      <div className="flex items-center justify-between px-4 lg:px-8 h-16">
        <div className="flex items-center gap-8">
          <a href="/" aria-label="Cisco home" className="flex items-center">
            <CiscoLogo className="h-10" color="#00bceb" />
          </a>

          <nav className="hidden lg:flex items-center">
            {navItems.map((item) => (
              <div
                key={item.label}
                className="relative"
                onMouseEnter={() => setOpenMenu(item.label)}
                onMouseLeave={() => setOpenMenu(null)}
              >
                <button className="flex items-center gap-1 px-4 py-5 text-sm font-medium text-[#23282e] hover:text-[#00bceb]">
                  {item.label}
                  <ChevronDown className="w-3.5 h-3.5" />
                </button>
                {openMenu === item.label && (
                  <div className="absolute left-0 top-full w-72 bg-white shadow-xl border border-gray-100 py-4 fade-up">
                    {item.sub.map((s) => (
                      <a key={s} href="#" className="block px-5 py-2 text-sm text-[#23282e] hover:bg-gray-50 hover:text-[#00bceb]">{s}</a>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-2">
          <button onClick={() => setSearchOpen((v) => !v)} className="p-2 hover:bg-gray-100 rounded-full" aria-label="Search">
            <Search className="w-5 h-5" />
          </button>
          <button className="p-2 hover:bg-gray-100 rounded-full" aria-label="Cart">
            <ShoppingCart className="w-5 h-5" />
          </button>
          <button className="p-2 hover:bg-gray-100 rounded-full hidden lg:inline-flex" aria-label="Account">
            <User className="w-5 h-5" />
          </button>
          <button onClick={() => setMobileOpen(true)} className="lg:hidden p-2 hover:bg-gray-100 rounded-full" aria-label="Menu">
            <Menu className="w-6 h-6" />
          </button>
        </div>
      </div>

      {searchOpen && (
        <div className="border-t border-gray-100 bg-white px-4 lg:px-8 py-4 fade-up">
          <input
            type="text"
            placeholder="Search Cisco.com"
            className="w-full border-b-2 border-gray-300 focus:border-[#00bceb] outline-none py-2 text-lg"
          />
        </div>
      )}

      {mobileOpen && (
        <div className="fixed inset-0 z-50 bg-white lg:hidden overflow-y-auto">
          <div className="flex items-center justify-between p-4 border-b">
            <CiscoLogo className="h-9" color="#00bceb" />
            <button onClick={() => setMobileOpen(false)} className="p-2"><X className="w-6 h-6" /></button>
          </div>
          <div className="p-4">
            {navItems.map((n) => (
              <details key={n.label} className="py-2 border-b">
                <summary className="cursor-pointer font-medium text-[#0d274d] py-2">{n.label}</summary>
                <div className="pl-3 pb-2">
                  {n.sub.map((s) => (
                    <a key={s} href="#" className="block py-1.5 text-sm text-gray-700">{s}</a>
                  ))}
                </div>
              </details>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
